export function formatValue(value, placeholder = '-') {
  if (value === undefined || value === null) {
    return placeholder
  } else {
    return value
  }
}
